import { ConnectDragPreview, ConnectDragSource, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { toggleDragState } from 'containers/App/actions';
import { CAROUSEL_ITEM_TYPES } from 'containers/Layouts/sagas/addCarousel';

type Props = {
  sectionId: string;
  carouselId: string;
  slideId: string;
  slideNumber: number;
};

export type CAROUSEL_ITEM_SLIDE_DRAG_TYPE = Props & {
  dragSourceType: CAROUSEL_ITEM_TYPES.SLIDE;
};

export const useCarouselItemSlideDragSource = (props: Props): {
  connectDragSource: ConnectDragSource;
  connectDragPreview: ConnectDragPreview;
} => {
  const dispatch = useDispatch();
  const dragSourceType = CAROUSEL_ITEM_TYPES.SLIDE;

  const [, connectDragSource, connectDragPreview] = useDrag<CAROUSEL_ITEM_SLIDE_DRAG_TYPE>({
    type: dragSourceType,
    item: () => {

      return {
        dragSourceType,
        ...props,
      };
    },

    end() {
      dispatch(toggleDragState());
    },
  });

  return {
    connectDragSource,
    connectDragPreview,
  };
};
